export const entityConfig = {
  bot: {
    type: 'bot',
    name: 'Bot',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'bot',
        stateUsage: {
          animClips: {
            idle: { clipName: '.idle', loop: true },
            onTakeDamage: '.damage',
            displaced: '.damage',
            run: { clipName: 'run_mid', loop: true },
            respawn: '.respawn',
            onDeath: '.death'
          },
          teamColorSlots: [
            'lights',
            'eyes'
          ]
          // ! Each part skin is listed with the part in bot-parts.config.json,
          // ! e.g. <"partSkin": "cat_body"> at the top level beside "resources".
          // ! This works, but may not be logically sound: the entry describes how to use
          // ! this resource, so it arguably belongs here instead.
          // ! Keeping it beside the part reduces repetition; that config only exists in
          // ! relation to this entity entry.
          // partSkinMap: {
          //   item_part_cat_default_platform: 'cat_body'
          // }
        }
      },
      explosionVfx: {
        type: 'multiAtlas',
        datasetKey: 'vfxExplosion',
        stateUsage: {
          animClips: {
            default: 'default'
          }
        }
      },
      sfxOnDeath: {
        type: 'audioTrack',
        datasetKey: 'bot_defeated',
        stateUsage: 'onDeath'
      },
      sfxOnReboot: {
        type: 'audioTrack',
        datasetKey: 'bot_reboot',
        stateUsage: 'onReboot'
      },
      sfxOnLoseLife: {
        type: 'audioTrack',
        datasetKey: 'loseLife',
        stateUsage: 'onLoseLife'
      },
      sfxOnHeal: {
        type: 'audioTrack',
        datasetKey: 'heal',
        stateUsage: 'onHeal'
      }
    },
    skills: [
      {
        datasetKey: 'item_hat_default',
        stateResourceUsage: {
          default: {
            animClips: {
              casting: 'shoot.begin',
              recovering: 'shoot.end'
            }
          }
        },
        deployPosOffset: 0.5
      }
    ],
    stats: {
      health: 500,
      armorElectrical: 0,
      armorMechanical: 0,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 0
    },
    structure: {
      scale_visualResources: 0.5,

      clickBounds_width: 1.85,
      clickBounds_height: 1.75,
      clickBounds_offset_x: 0.1,
      clickBounds_offset_y: -0.45,

      radius_collider_nav: 0.25,
      radius_collider_hurtbox: 0.4
    },
    data: {
      showDebugStats: true,
      debugStatsOffsetY: -370,
      hpBarOffsetY: -175,
      playExplosionVfxOnDeath: false,
      flashOnDamage: {
        interval: 250,
        times: 1
      },
      aiConfig: {
        hurtboxSensorRadius: 5,
        partSkillSpamDelayAI: [7, 11], // seconds
        partSkillSpamDelayPlayerAuto: [6, 10], // seconds
        refreshRateMS: 500
      },
      miniMapFrames: ['map-current-player', 'map-ally-player', 'map-enemy-player']
    }
  },
  tr_ant: {
    type: 'tr_ant',
    name: 'Minion Ant',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'minion_ant',
        stateUsage: {
          animClips: {
            onTakeDmg: 'anim_damage',
            idle: { clipName: 'anim_idle', loop: true },
            run: { clipName: 'anim_walk', loop: true },
            onDeath: 'anim_death'
          },
          teamColorSlots: [
            'color-butt_light',
            'color-antenna_light',
            'color-eye_light',
            'color-antenna_light2',
            'color-body_light'
          ]
        }
      },
      explosionVfx: {
        type: 'multiAtlas',
        datasetKey: 'vfxExplosion',
        stateUsage: {
          animClips: {
            default: 'default'
          }
        }
      },
      sfxMinionDefeat: {
        type: 'audioTrack',
        datasetKey: 'minion_defeated',
        stateUsage: 'onDeath'
      }
    },
    skills: [
      {
        datasetKey: 'antPincer',
        stateResourceUsage: {
          default: {
            animClips: {
              casting: 'anim_attack'
            }
          }
        }
      }
    ],
    stats: {
      health: 150,
      armorElectrical: 0,
      armorMechanical: 0,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 2.5
    },
    structure: {
      scale_visualResources: 0.275,

      clickBounds_width: 1.55,
      clickBounds_height: 1.25,
      clickBounds_offset_x: 0.1,
      clickBounds_offset_y: -0.3,

      radius_collider_nav: 0.25,
      radius_collider_hurtbox: 0.4
    },
    data: {
      showDebugStats: true,
      aiAggroSensorRange: 4,
      debugStatsOffsetY: -330,
      hpBarOffsetY: -120,
      playExplosionVfxOnDeath: false,
      flashOnDamage: {
        interval: 250,
        times: 1
      },
      aiConfig: {
        hurtboxSensorRadius: 4,
        refreshRateMS: {
          idle: 800,
          engaging: 500
        }
      },
      miniMapFrames: ['', 'map-ally-minion', 'map-enemy-minion']
    }
  },
  minion_drone: {
    type: 'minion',
    name: 'Little Drone',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'minion_drone',
        stateUsage: {
          animClips: {
            onTakeDmg: 'dmg',
            idle: { clipName: 'idle', loop: true },
            run: { clipName: 'walk', loop: true }
          },
          shade_TeamColour: 'drone_2.png'
        }
      },
      sfxAttack: {
        type: 'audioTrack',
        datasetKey: 'minion_attack'
      }
    },
    skills: [
      {
        datasetKey: 'shootHomingEnergyPellet',
        stateResourceUsage: {
          default: {
            animClips: {
              recovering: 'attack'
            }
          }
        }
      }
    ],
    stats: {
      health: 200,
      armorElectrical: 0,
      armorMechanical: 0,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 1
    },
    structure: {
      scale_visualResources: 0.5,
      clickBounds_radius: 0.4,
      radius_collider_nav: 0.25,
      radius_collider_hurtbox: 0.4
    },
    data: {
      showDebugStats: true,
      debugStatsOffsetY: -400,
      hpBarOffsetY: -100,
      flashOnDamage: {
        interval: 250,
        times: 1
      }
    }
  },
  puffballFollower: {
    type: 'follower',
    name: 'puffball follower',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'puffball_follower',
        stateUsage: {
          animClips: {
            idle: { clipName: 'idle', loop: true },
            run: { clipName: 'run', loop: true },
            startup: { clipName: 'spawn.create', loop: false },
            attack: { clipName: '.shoot', loop: false },
            // "onDeath": { "clipName": "spawn.create", "loop": true, "reverse": true },
            onDeath: { clipName: 'deactivated', loop: false }
          },
          shade_TeamColour: 'PuffBot_2.png'
        }
      }
    },
    skills: [
      {
        datasetKey: 'shootHomingPuffballPellet',
        stateResourceUsage: {
          default: {
            animClips: {
              casting: '.shoot'
            }
          }
        }
      }
    ],
    stats: {
      health: 350,
      armorElectrical: 0,
      armorMechanical: 0,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 2.5
    },
    structure: {
      scale_visualResources: 0.5,
      clickBounds_radius: 0.4,
      radius_collider_nav: 0.25,
      radius_collider_hurtbox: 0.4
    },
    data: {
      showDebugStats: true,
      aiAggroSensorRange: 2.5,
      debugStatsOffsetY: -400,
      hpBarOffsetY: -100,
      flashOnDamage: {
        interval: 250,
        times: 1
      },
      startupTime: 1000,
      aiConfig: {
        followDistance: 1,
        endPointCheckMargin: 10,
        hurtboxSensorRadius: 4,
        refreshRateMS: {
          idle: 800,
          engaging: 500
        }
      }
    }
  },
  ramFollower: {
    type: 'follower',
    name: 'ram follower',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'ram_bot',
        stateUsage: {
          animClips: {
            startup: { clipName: 'spawn', loop: false },
            idle: { clipName: 'idle', loop: true },
            run: { clipName: 'run', loop: true },
            charge: { clipName: 'run.charge', loop: false },
            attack: { clipName: 'headbutt_a', loop: false },
            hit: { clipName: 'hit', loop: false },
            onDeath: { clipName: 'death.dark', loop: false }
          },
          shade_TeamColour: 'RamBot_2.png'
        }
      }
    },
    skills: [
      {
        datasetKey: 'ramRush',
        stateResourceUsage: {
          default: {
            animClips: {
              channeling: 'run.charge',
              recovering: 'headbutt_a'
            }
          }
        }
      }
    ],
    stats: {
      health: 1000,
      armorElectrical: 0,
      armorMechanical: 0,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 2
    },
    structure: {
      scale_visualResources: 0.5,

      clickBounds_width: 1.85,
      clickBounds_height: 1.75,
      clickBounds_offset_x: 0.1,
      clickBounds_offset_y: -0.45,

      radius_collider_nav: 0.25,
      radius_collider_hurtbox: 0.4
    },
    data: {
      showDebugStats: true,
      aiAggroSensorRange: 2.5,
      debugStatsOffsetY: -400,
      hpBarOffsetY: -200,
      flashOnDamage: {
        interval: 250,
        times: 1
      },
      startupTime: 1200,
      aiConfig: {
        exitEngagingToFollowDistance: 3,
        followDistance: 1,
        hurtboxSensorRadius: 4,
        refreshRateMS: {
          idle: 800,
          engaging: 500
        },
        targetPriorityOrder: ['Bot', 'Tower', 'TowerZr', 'TowerZrBase', 'AntOr', 'AntBase']
      }
    }
  },
  building_tower_common: {
    name: 'Tower',
    resources: {
      sfxTowerDefeat: {
        type: 'audioTrack',
        datasetKey: 'tower_destroyed',
        stateUsage: 'onDeath'
      }
    },
    stats: {
      health: 185,
      armorElectrical: 70,
      armorMechanical: 70,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 0
    },
    structure: {
      clickBounds_width: 2,
      clickBounds_height: 1.75,

      width_collider_nav: 1.25,
      height_collider_nav: 1,
      width_collider_hurtbox: 1.5,
      height_collider_hurtbox: 1.25
    },
    data: {
      heightToTowerPeak: -230,
      showDebugStats: true,
      flashOnDamage: {
        interval: 150,
        times: 1
      },
      miniMapFrames: ['', 'map-ally-tower', 'map-enemy-tower']
    }
  },
  powerGenerator: {
    type: 'powerGenerator',
    name: 'Power Generator',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'building_power_generator',
        stateUsage: {
          spineSkin: {
            byGreaterHpValue: [
              { value: 50, skin: 'state_01' },
              { value: 0, skin: 'state_02' }
            ],
            onDeath: 'state_broken'
          },
          animClips: {
            idle: { clipName: 'idle', loop: true },
            idleNoAnim: 'static',
            onDeath: { clipName: 'destroy', timeToMatch: 1500, loop: false }
          }
        }
      }
    },
    skills: [],
    stats: {
      health: 250,
      armorElectrical: 0,
      armorMechanical: 0,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 0
    },
    structure: {
      clickBounds_radius: 1,
      radius_collider_nav: 1,
      width_collider_hurtbox: 1.75,
      height_collider_hurtbox: 1.5,
      width_collider_nav: 1.5,
      height_collider_nav: 1.25
    },
    data: {
      showDebugStats: true,
      debugStatsOffsetY: -400,
      heightToTowerPeak: -275,
      hpBarOffsetY: -275,
      flashOnDamage: {
        interval: 250,
        times: 1
      }
    }
  },
  fountain: {
    type: 'fountain',
    name: 'fountain',
    resources: {},
    stats: {
      health: 0,
      armorElectrical: 0,
      armorMechanical: 0,
      powerElectrical: 0,
      powerMechanical: 0,
      speedMove: 0
    },
    structure: {
      radius_collider_hitbox: 2
    }
  },
  energyBall: {
    type: 'bullet',
    name: 'Energy Ball',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'projRoleskillDefault',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.1,
      radius_collider_hitbox: 0.1
    }
  },
  energyPellet: {
    type: 'bullet',
    name: 'Energy Pellet',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'effects',
        stateUsage: {
          animClips: {
            idle: { clipName: 'projectile02', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.1,
      radius_collider_hitbox: 0.1
    }
  },
  blitzPellet: {
    type: 'bullet',
    name: 'Blitz Pellet',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'blitz_pellet',
        stateUsage: {
          animClips: {
            idle: { clipName: 'pellet', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.1,
      radius_collider_hitbox: 0.1
    }
  },
  energyDiamond: {
    type: 'bullet',
    name: 'Energy Diamond (currently using by tower)',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'projTower',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.25
    }
  },
  bouncingBullet: {
    type: 'bullet',
    name: 'Bouncing Bullet',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'projRoleskillBounceBack',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.25,
      radius_collider_targeting: 2.0
    }
  },
  burstingBullet: {
    type: 'bullet',
    name: 'Bursting Bullet',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'projRoleskillSupersoak',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      },
      burstArea: {
        type: 'multiAtlas',
        datasetKey: 'aoeBurstSuperSoak',
        stateUsage: {
          animClips: {
            onDeath: { clipName: 'default', loop: false }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.25,
      radius_collider_targeting: 1.0
    }
  },
  projRoleskillTripleThreat: {
    type: 'bullet',
    name: 'Self Defense Projectile',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'projRoleskillTriplethreat',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.25
    }
  },
  projRoleskillDoubleTime: {
    type: 'bullet',
    name: 'Self Defense Projectile',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'projRoleskillDoubletime',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.25
    }
  },
  projRoleskillSelfDefense: {
    type: 'bullet',
    name: 'Self Defense Projectile',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'projRoleskillSelfDefense',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.25
    }
  },
  smokeBomb: {
    type: 'bomb',
    name: 'Smoke Bomb',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'effects',
        stateUsage: {
          animClips: {
            onSpawn: 'burstUp',
            idle: { clipName: 'linger', loop: true },
            onDeath: 'dissipate'
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_hitbox: 1.5
    }
  },
  piercingMark: {
    type: 'bomb',
    name: 'Smoke Bomb',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'effects',
        stateUsage: {
          animClips: {
            land: 'markLanding'
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_hitbox: 0.125
    }
  },
  bouncyBomb: {
    type: 'bomb',
    name: 'Bouncy Bomb',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'bouncyBomb',
        stateUsage: {
          animClips: {
            bounce: { clipName: 'Projectile', loop: true },
            land: 'End',
            wait: { clipName: 'Loop', loop: true },
            explode: 'Explosion'
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.15,
      radius_collider_hitbox: 0.25
    }
  },
  boneMine: {
    type: 'bomb',
    name: 'Bone Mine',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'boneMine',
        stateUsage: {
          animClips: {
            plant: 'plant',
            wait: { clipName: 'mine', loop: true },
            popUp: 'activate',
            spin: { clipName: 'spin', loop: true },
            explode: 'explosion'
          }
        }
      }
    },
    stats: {
      health: 200
    },
    structure: {
      radius_collider_hitbox: 0.25
    }
  },
  warpPad: {
    type: 'device',
    name: 'Warp pad',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'effects',
        stateUsage: {
          animClips: {
            idle: { clipName: 'roarSplash', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_hitbox: 0.5
    }
  },
  door: {
    type: 'device',
    name: 'Door',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'doors',
        stateUsage: {
          frames: {
            closed_locked: 'closed',
            opened: 'opened_teal_blue'
          },
          animClips: {
            opening: { clipName: 'open', timeToMatch: 1500 },
            closing: { clipName: 'open', timeToMatch: 750, reverse: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      width_collider_nav: 1,
      height_collider_nav: 4
    }
  },
  energyWaveSmall: {
    type: 'wave',
    name: 'Energy Wave Small',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'blueWaveBlast',
        stateUsage: {
          animClips: {
            default_Head: 'sideWaveHead',
            default_Tail: 'sideWaveTail'
          }
        }
      }
    },
    stats: {
      powerElectrical: 120
    },
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.375
    }
  },
  energyWaveLarge: {
    type: 'wave',
    name: 'Energy Wave Large',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'blueWaveBlast',
        stateUsage: {
          animClips: {
            default_Head: 'mainWaveHead',
            default_Tail: 'mainWaveTail'
          }
        }
      }
    },
    stats: {
      powerElectrical: 350
    },
    structure: {
      radius_collider_nav: 0.5,
      radius_collider_hitbox: 0.65
    }
  },
  lightningBoltProjectile: {
    type: 'bolt',
    name: 'Lightning Bolt',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'counterCowerSkill',
        stateUsage: {
          animClips: {
            idle: 'lightningBoltProjectileClip'
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.25
    }
  },
  fearAOE: {
    type: 'AOE',
    name: 'Fear AOE',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'counterCowerSkill',
        stateUsage: {
          animClips: {
            casting: 'fearAreaEffectClip'
          }
        }
      }
    },
    stats: {
    },
    structure: {
      radius_collider_hitbox: 3
    }
  },
  coiledPulseBomb: {
    type: 'bomb',
    name: 'Coiled Pulse Bomb',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'curlyCorkSkillA',
        stateUsage: {
          animClips: {
            totemCast: { clipName: 'totemCastClip', loop: false },
            totemSpawn: { clipName: 'totemSpawnClip', loop: false },
            totemLoop: { clipName: 'totemLoopClip', loop: true },
            spinStart: { clipName: 'spinStartClip', loop: false },
            spinLoop: { clipName: 'spinLoopClip', loop: true },
            spinJump: { clipName: 'spinJumpClip', loop: false },
            spinEnd: { clipName: 'spinEndClip', loop: false }
          }
        }
      },
      pulseVfx: {
        type: 'multiAtlas',
        datasetKey: 'curlyCorkSkillB',
        stateUsage: {
          animClips: {
            pulse1Blue: 'pulse1BlueClip',
            pulse2Orange: 'pulse2OrangeClip',
            pulse3Red: 'pulse3RedClip'
          }
        }
      }
    },
    stats: {
    },
    structure: {
      radius_collider_hitbox: 2
    }
  },
  multiPulseAOE: {
    type: 'AOE',
    name: 'Curly Cork Explosion',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'curlyCorkSkillB',
        stateUsage: {
          animClips: {
            explosion1: 'explosion1Clip',
            explosion2: 'explosion2Clip',
            explosion3: 'explosion3Clip'
          }
        }
      }
    },
    stats: {
    },
    structure: {
      radius_collider_hitbox: 2
    }
  },
  homingHairballProjectile: {
    type: 'hairballProjectile',
    name: 'Homing Hairball Projectile',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'hairballSkill',
        stateUsage: {
          animClips: {
            idle: { clipName: 'projectileHairball', loop: true },
            onDeath: { clipName: 'explosionHairball', loop: false }
          }
        }
      },
      trail: {
        type: 'image',
        datasetKey: 'salivaPool',
        stateUsage: 'particle'
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.375,
      radius_visual: 0.9
    },
    data: {
      timeGrowToFullSize: 0.6,
      trailEmitGapTime: 400,
      trailParticleLifeTime: 800
    }
  },
  sludgePuddle: {
    type: 'hazardZone',
    name: 'Sludge Puddle',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'slobSludgeSkill',
        stateUsage: {
          animClips: {
            startup: { clipName: 'spawn', loop: false },
            active: { clipName: 'loop', loop: true },
            onDeath: { clipName: 'disappear', loop: false }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_hitbox: 3
    }
  },
  yellowArc: {
    type: 'bullet',
    name: 'Yellow Arc',
    resources: {
      default: {
        type: 'multiAtlas',
        datasetKey: 'yellowArcProjectile',
        stateUsage: {
          animClips: {
            idle: { clipName: 'default', loop: true }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.2,
      radius_collider_hitbox: 0.2
    }
  },

  maneTrail: {
    type: 'trail',
    name: 'Mane Trail',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'skill_mane_event',
        stateUsage: {
          animClips: {
            startup: { clipName: 'mane_event_fireFloor.begin', loop: false },
            active: { clipName: 'mane_event_fireFloor.cycle', loop: true },
            onDeath: { clipName: 'mane_event_fireFloor.end', loop: false }
          }
        }
      }
    },
    stats: {},
    structure: {
      width_collider_hitbox: 0.7,
      height_collider_hitbox: 0.25
    }
  },
  heal_orb: {
    type: 'orb',
    name: 'Heal Orb',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'heal_orb',
        stateUsage: {
          spineSkin: {
            idle: 'normal pack'
          },
          animClips: {
            activating: { clipName: 'activating' },
            activationFinishes: { clipName: 'activation_finishes' },
            idle: { clipName: 'idle', loop: true }
          }
        }
      },
      vfx: {
        type: 'spineAtlas',
        datasetKey: 'skill_static_sprint',
        stateUsage: {
          animClips: {
            heal_effect: { clipName: 'heal_effect', loop: false }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.5,
      radius_collider_targeting: 2.0
    },
    data: {
      respawn_timer: 20000,
      heal_percent: 0.25,
      miniMapFrames: ['map-healthpack']
    }
  },
  dm_objective: {
    type: 'dm_objective',
    name: 'Domination Objective Circle',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'capture_point',
        stateUsage: {
          animClips: {
            activateAlly: { clipName: 'activate_ally' },
            activateEnemy: { clipName: 'activate_enemy' },
            neutral: { clipName: 'neutral' }
          }
        }
      },
      sfxOnCapture: {
        type: 'audioTrack',
        datasetKey: 'point_captured',
        stateUsage: 'onCapture'
      }
    },
    stats: {},
    structure: {
      radius_collider_hitbox: 2
    },
    data: {
      miniMapFrames: ['map-neutral-point']
    }
  },
  dm_gate: {
    type: 'dm_gate',
    name: 'Domination Gate',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'dm_gate',
        stateUsage: {
          animClips: {
            close: { clipName: 'close' },
            open: { clipName: 'open' }
          }
        }
      }
    },
    stats: {},
    structure: {
      width_collider_nav: 1,
      height_collider_nav: 6
    },
    data: {
      lockDuration: 10000
    }
  },
  heal_orb_large: {
    type: 'orb_large',
    name: 'Heal Orb Large',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'heal_orb',
        stateUsage: {
          spineSkin: {
            idle: 'big pack'
          },
          animClips: {
            activating: { clipName: 'activating' },
            activationFinishes: { clipName: 'activation_finishes' },
            idle: { clipName: 'idle', loop: true }
          }
        }
      },
      vfx: {
        type: 'spineAtlas',
        datasetKey: 'skill_static_sprint',
        stateUsage: {
          animClips: {
            heal_effect: { clipName: 'heal_effect', loop: false }
          }
        }
      }
    },
    stats: {},
    structure: {
      radius_collider_nav: 0.25,
      radius_collider_hitbox: 0.5,
      radius_collider_targeting: 2.0
    },
    data: {
      respawn_timer: 28000,
      heal_percent: 0.45,
      miniMapFrames: ['map-healthpack']
    }
  }
} as const;

export const extendedEntityConfig = {
  bot_dm: {
    type: 'bot_dm',
    name: 'Domination Bot',
    extends: 'bot',
    data: {
      aiConfig: {
        strategyRefreshRateMS: 20000,
        prepareDuration: 11000,
        releaseTargetTimer: 5000,
        hurtboxSensorRadius: 4,
        idleInObjTimeCap: 4000
      }
    }
  },
  ant_dm: {
    type: 'ant_dm',
    name: 'Domination Ant',
    extends: 'tr_ant',
    stats: {
      health: 200,
      speedMove: 1
    },
    structure: {
      scale_visualResources: 0.275
    },
    data: {
      aiConfig: {
        prepareDuration: 1000,
        releaseTargetTimer: 2000,
        hurtboxSensorRadius: 2,
        refreshRateMS: {
          idle: 100
        }
      }
    }
  },
  ant_tutorial: {
    type: 'ant_tutorial',
    name: 'Tutorial Ant',
    extends: 'tr_ant',
    stats: {
      health: 10
    },
    structure: {
      scale_visualResources: 0.275
    },
    data: {
      aiConfig: {
        hurtboxSensorRadius: 20
      }
    }
  },
  building_tower: {
    type: 'tower',
    extends: 'building_tower_common',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'building_tower',
        stateUsage: {
          spineSkin: {
            byGreaterHpValue: [
              { value: 50, skin: 'state_01' },
              { value: 0, skin: 'state_02' }
            ],
            onDeath: 'state_broken'
          },
          animClips: {
            idle: 'idle',
            onDeath: 'destroy'
          },
          shade_TeamColour: 'tower.png'
        }
      }
    },
    skills: [
      {
        datasetKey: 'shootEnergyDiamond',
        stateResourceUsage: {
          default: {
            animClips: {
              casting: 'charge',
              recovering: 'shoot'
            }
          }
        }
      }
    ],
    data: {
      aiConfig: {},
      heightToTowerPeak: -230,
      debugStatsOffsetY: -400,
      hpBarOffsetY: -275,
      outlineAssetKey: 'towerOutlineOR',
      outlineScale: 1,
      outlineOffsetY: -45
    }
  },
  building_tower_dm: {
    type: 'tower_dm',
    name: 'Domination Tower',
    extends: 'building_tower_common',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'building_tower_dom',
        stateUsage: {
          animClips: {
            spawn: 'spawn',
            idle: { clipName: 'idle', loop: true },
            attack: 'attack',
            onDeath: 'destroy',
            destroy: 'dead'
          },
          shade_TeamColour: 'full_tower_2.png'
        }
      }
    },
    stats: {
      health: 3000
    },
    skills: [
      {
        datasetKey: 'shootHomingEnergyPellet_capturePoint',
        stateResourceUsage: {
          default: {
            animClips: {
              casting: 'attack'
            }
          }
        }
      }
    ],
    structure: {
      clickBounds_width: 2.5,
      clickBounds_height: 2.25,

      width_collider_nav: 1.5,
      height_collider_nav: 1.25,

      width_collider_hurtbox: 1.75,
      height_collider_hurtbox: 1.5
    },
    data: {
      heightToTowerPeak: -395,
      debugStatsOffsetY: -430,
      hpBarOffsetY: -450,
      outlineAssetKey: 'towerOutlineCM',
      outlineScale: 2,
      outlineOffsetY: -145,
      aiConfig: {
        releaseTargetTimer: 6000,
        targetPriorityOrder: ['RamFollower', 'AntZr', 'BotDM']
      }
    }
  },
  building_tower_dm_base: {
    type: 'tower_dm_base',
    name: 'Domination Base Tower',
    extends: 'building_tower_common',
    resources: {
      default: {
        type: 'spineAtlas',
        datasetKey: 'building_tower_dom',
        stateUsage: {
          animClips: {
            spawn: 'spawn',
            idle: { clipName: 'idle', loop: true },
            attack: 'attack',
            onDeath: 'destroy',
            destroy: 'dead'
          },
          shade_TeamColour: 'full_tower_2.png'
        }
      },
      shield: {
        type: 'spineAtlas',
        datasetKey: 'vfx_tower_shield',
        stateUsage: {
          animClips: {
            ally_shield: { clipName: 'ally_shield', loop: true },
            enemy_shield: { clipName: 'enemy_shield', loop: true }
          }
        }
      }
    },
    skills: [
      {
        datasetKey: 'shootHomingEnergyPellet',
        stateResourceUsage: {
          default: {
            animClips: {
              casting: 'attack'
            }
          }
        }
      }
    ],
    structure: {
      clickBounds_width: 2.5,
      clickBounds_height: 2.25,

      width_collider_nav: 1.5,
      height_collider_nav: 1.25,

      width_collider_hurtbox: 1.75,
      height_collider_hurtbox: 1.5
    },
    data: {
      heightToTowerPeak: -395,
      debugStatsOffsetY: -430,
      hpBarOffsetY: -450,
      aiConfig: {
        targetPriorityOrder: ['RamFollower', 'AntZr', 'BotDM']
      }
    }
  }
} as const;
